import { render, staticRenderFns } from "./Atribuir.vue?vue&type=template&id=fc0ec1f2&"
import script from "./Atribuir.vue?vue&type=script&lang=js&"
export * from "./Atribuir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports